import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from "react-helmet";
const TenantHelmet = ({ helmetProps }) => {
    const { title, description, favicon, thumbnailUrl } = helmetProps;
    return (_jsxs(Helmet, { children: [title && _jsx("title", { children: title }), description && _jsx("meta", { name: "description", content: description }), favicon && _jsx("link", { rel: "icon", href: favicon }), thumbnailUrl && _jsx("link", { rel: "apple-touch-icon", href: thumbnailUrl })] }));
};
export default TenantHelmet;
